export const MIME_TYPE_CSV = 'text/csv';
export type FileType = typeof MIME_TYPE_CSV;
